<template>
	<div :class="containerClass" @click="onDocumentClick">
		<AppTopBar :topbarMenuActive="topbarMenuActive" :activeTopbarItem="activeTopbarItem" :horizontal="isHorizontal()" :profileMode="profileMode"
					@menubutton-click="onMenuButtonClick" @topbar-menubutton-click="onTopbarMenuButtonClick" @topbar-item-click="onTopbarItemClick"></AppTopBar>

		<transition name="layout-menu-container">
			<div class="layout-menu-container" @click="onMenuClick" v-show="isMenuVisible()">
				<div class="layout-menu-logo">
					<router-link :to="'/home'">
						<button class="p-link nome-sistema">
							<img id="layout-menu-logo" src="assets/layout/images/logo_tribunal.png" alt="Tribunal de contas do Estado do Amazonas"/>
							<p>Sistema de Processos Seletivos</p>
						</button>
					</router-link>
				</div>
				<div class="layout-menu-wrapper">
					<div class="menu-scroll-content">
						<AppInlineProfile v-if="displayInlineProfile" @profile-click="onProfileClick" :expanded="profileExpanded"></AppInlineProfile>
						<AppMenu :model="menuUsuario" :layoutMode="layoutMode" :active="menuActive" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
					</div>
				</div>
			</div>
		</transition>

		<div class="layout-main">
			<AppBreadcrumb></AppBreadcrumb>

			<div class="layout-content">
				<router-view/>
			</div>

			<AppFooter/>
		</div>

		<Loading/>

		<div v-if="staticMenuMobileActive" class="layout-mask"></div>
	</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppInlineProfile from './AppInlineProfile.vue';
import AppMenu from './AppMenu.vue';
import AppBreadcrumb from './AppBreadcrumb.vue';
import AppFooter from './AppFooter.vue';
import EventBus from './event-bus';
import { logoutMixin } from '@/mixins'
import PermissaoService from './service/PermissaoService';
import Loading from './components/Loading.vue';

export default {

	mixins: [logoutMixin],

	data() {
		return {
			layoutMode: 'static',
			staticMenuDesktopInactive: false,
			staticMenuMobileActive: false,
			overlayMenuActive: false,
			topbarMenuActive: false,
			activeTopbarItem: null,
			menuActive: false,
			darkMenu: false,
			profileMode: 'popup',
			profileExpanded: false,
			grouped: true,
			menuGrouped: Array,
			menuUngrouped: Array,
			perfil: null,
			permissoes: null,
			menuUsuario: null
		}
	},
	permissaoService: null,
	created() {
		this.permissaoService = new PermissaoService();
	},
	mounted() {
		this.menu();
	},
	watch: {
		$route() {
			this.menuActive = false;
			this.$toast.removeAllGroups();
		},
		processoSelecionado() {
			console.log("wath processo selecionado");
			this.processo = this.$store.state.processoSelecionado;
			this.menu();
		}
	},

	methods: {
		onDocumentClick() {
			if (!this.topbarItemClick) {
				this.activeTopbarItem = null;
				this.topbarMenuActive = false;
			}

			if (!this.menuClick) {
				if (this.isHorizontal() || this.isSlim()) {
					EventBus.$emit('reset_active_index');
					this.menuActive = false;
				}
				this.hideOverlayMenu();
			}

			if(!this.profileClick) {
				if (this.isSlim()) {
					this.profileExpanded = false;
				}
			}

			this.topbarItemClick = false;
			this.menuClick = false;
			this.profileClick = false;
		},
		onMenuButtonClick(event) {
			this.menuClick = true;
			this.topbarMenuActive = false;

			if (this.layoutMode === 'overlay') {
				if (this.isDesktop())
					this.overlayMenuActive = !this.overlayMenuActive;
				else
					this.staticMenuMobileActive = !this.staticMenuMobileActive;
			}
			else {
				if (this.isDesktop())
					this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
				else
					this.staticMenuMobileActive = !this.staticMenuMobileActive;
			}

			event.preventDefault();
		},
		onTopbarMenuButtonClick(event) {
			this.topbarItemClick = true;
			this.topbarMenuActive = !this.topbarMenuActive;
			this.hideOverlayMenu();
			event.preventDefault();
		},
		onTopbarItemClick(event) {
			this.topbarItemClick = true;

			if (this.activeTopbarItem === event.item)
				this.activeTopbarItem = null;
			else
				this.activeTopbarItem = event.item;

			event.originalEvent.preventDefault();
		},
		onMenuClick() {
			this.menuClick = true;
		},
		isMenuVisible() {
			if (this.isDesktop()) {
				if (this.layoutMode === 'static')
					return !this.staticMenuDesktopInactive;
				else if (this.layoutMode === 'overlay')
					return this.overlayMenuActive;
				else
					return true;
			} else {
				return true;
			}
		},
		onProfileClick(event) {
			this.profileClick = true;
			this.profileExpanded = !this.profileExpanded;
			if(this.isHorizontal() || this.isSlim()) {
				EventBus.$emit('reset_active_index');
			}

			event.preventDefault();
		},
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
			this.staticMenuDesktopInactive = false;
			this.overlayMenuActive = false;

			if(this.isHorizontal()) {
				this.profileMode = 'popup'
			}
		},
		onMenuTypeChange(menuType) {
			this.grouped = menuType;
		},
		onMenuColorChange(menuColor) {
			this.darkMenu = menuColor;
		},
		onProfileModeChange(profileMode) {
			this.profileMode = profileMode;
		},
		isHorizontal() {
			return this.layoutMode === 'horizontal';
		},
		isSlim() {
			return this.layoutMode === 'slim';
		},
		hideOverlayMenu() {
			this.overlayMenuActive = false;
			this.staticMenuMobileActive = false;
		},
		isDesktop() {
			return window.innerWidth > 1024;
		},
		isMobile() {
			return window.innerWidth <= 640;
		},

		onMenuItemClick(event) {

			if(event.item.label==='Sair'){
				this.efetuarLogout();
			}

			if (!event.item.items) {
				EventBus.$emit('reset_active_index');
				this.hideOverlayMenu();
			}
			if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
				this.menuActive = false;
			}
		},
		onRootMenuItemClick() {
			this.menuActive = !this.menuActive;
		},

		menu(){

			// if(this.menuUsuario!=null){
			// 	return this.menuUsuario;
			// }
			if(this.$store.state.perfil==="ADMIN"){
				this.menuUsuario = this.menuAdministrativo(this.processoSelecionado);
			}else{
				this.menuUsuario = this.menuCandidato();
			}

			return this.menuUsuario;
		},

		menuAdministrativo(){
			this.$store.state.dlgLoading = true;
			this.permissaoService.getMenuUsuario(this.$store.state.usuario, this.processoSelecionado)
				.then(menu => {
				 	this.menuUsuario=menu;
					this.$store.state.dlgLoading = false;
				});
		},

		menuCandidato(){
			return  [
				{
					label: 'Menu', icon: 'pi pi-fw pi-home',
					items: [
						{label: 'Processo em andamento', icon: 'pi pi-fw pi-inbox', to: { name: 'processo.em.andamento'}},
						{label: 'Minhas inscrições', icon: 'pi pi-fw pi-check-square', to: { name: 'minha.inscricao'}},
						{label: 'Meu cadastro', icon: 'pi pi-fw pi-user', to: { name: 'meu.cadastro'}},
						{label: 'Alterar minha senha', icon: 'pi pi-fw pi-key', to: { name: 'alterar.senha'}}
					]
				},
				{
					label: '', icon: '',
					items: [
						{label: 'Sair', icon: 'pi pi-fw pi-sign-out', to: '/' },
					]
				}
			];
		}
	},

	computed: {
		containerClass() {
			return ['layout-wrapper', {
				'layout-horizontal': this.layoutMode === 'horizontal',
				'layout-overlay': this.layoutMode === 'overlay',
				'layout-static': this.layoutMode === 'static',
				'layout-slim': this.layoutMode === 'slim',
				'layout-static-inactive': this.staticMenuDesktopInactive,
				'layout-mobile-active': this.staticMenuMobileActive,
				'layout-overlay-active': this.overlayMenuActive,
				'layout-menu-dark': this.darkMenu,
				'layout-menu-light':!this.darkMenu,
				'p-input-filled': this.$appState.inputStyle === 'filled'
			}];
        },
        displayInlineProfile() {
            return this.profileMode === 'inline' && this.layoutMode !== 'horizontal'
        },
    	processoSelecionado() {
			return this.$store.state.processoSelecionado;
		},
	},
	components: {
		'AppTopBar': AppTopBar,
		'AppInlineProfile': AppInlineProfile,
		'AppMenu': AppMenu,
		'AppBreadcrumb': AppBreadcrumb,
		'AppFooter': AppFooter,
		'Loading': Loading,
	}
}
</script>

<style lang="scss">
	@import 'App.scss';
</style>
